export const en = {
    'robot-ne-smozhet-vvesti':
        'To confirm that you are a human and not a program, please type the characters below. We ask you to do this from time to time to better ensure your data privacy.',
    send: 'Upload',
    'vvedite-simvoly-s-kartinki': 'Enter characters'
};
